import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom, Subscription } from 'rxjs';
import {
  convertUTCStringToOffset,
  getFormattedDate,
  getFormattedDateTime,
  getRegionCurrency,
  isLargeScreen,
} from '../../../../../global.variable';
import { AppService } from '../../../../app.service';
import { ConfirmDialogComponent } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { MediaPreviewComponent } from '../../../../shared/components/media-preview/media-preview.component';
import { FileUploadComponent } from '../../../../shared/components/file-upload/file-upload.component';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { DataCheckService } from '../../../../shared/services/data-check.service';
import { DeviceInfoService } from '../../../../shared/services/device-info.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { WebSocketService } from '../../../../shared/services/web-socket.service';
import { ClientsService } from '../../clients/clients.service';
import { JobsService } from '../jobs.service';
import { AddScheduledReportsComponent } from '../../../../shared/components/add-scheduled-reports/add-scheduled-reports.component';
import { ModifyLetterheadLogoComponent } from '../../../../shared/components/modify-letterhead-logo/modify-letterhead-logo.component';
import { PagesService } from '../../pages.service';
import fa from '@angular/common/locales/fa';
import { SelectSubBillerComponent } from '../../../../shared/components/select-sub-biller/select-sub-biller.component';
@Component({
  selector: 'gtapp-job-review',
  templateUrl: './job-review.component.html',
  styleUrl: './job-review.component.scss',
  standalone: false,
})
export class JobReviewComponent implements OnInit, OnDestroy {
  jobReportPreviewData: any;
  detailData: any;
  dialogRef: any;
  job_details: any;
  eventData: any = [];
  summaryData: any = [];

  eventIdsInReport: any = [];

  newComment: any;
  previousComment: any;
  statusTimeStamps: any = [];

  externalNewJobId: any;
  externalOldJobId: any;
  updatedJobExtraInfo: any;
  jobCompleteInvoiceRelatedStatus: any = {};

  largeView: Boolean = isLargeScreen;
  lastStatus: any;
  webSocketSubscription: any;
  subscriberUserId: any;
  loggedInDeviceID: string = this.deviceInfoService.getUniqueDeviceID();
  isAdmin: boolean = false;
  isDispatchUser: boolean = false;
  showHeader: boolean = true;

  monitoringCompanyList: any = [];

  mcInputValue: any;
  previousResponseTypeValue: any;
  responseTypeList: any = [];
  initalResponseTypeList: any = [];

  serviceTypeListData: any = [];
  initalServiceTypeListData: any = [];
  previousServiceTypeValue: any;

  reportRecipientContactsDataDict: any = {
    site_contacts: [],
    client_contacts: [],
  };

  selectedReportRecipientSet = new Set();

  customStatusOrder = [-1, 0, 8, 4, 5, 1];
  // -1 = recieved_at time
  sealInfo: any = {};

  eventsOutsideStatusTimeStamps: any = [];
  timeZoneOffset: any;
  welfareCheckPresent: boolean = false;
  photoUploadPresent: boolean = false;
  cpScanPresent: boolean = false;
  completedTasksPresent: boolean = false;
  hasStatusUpdates: boolean = false;
  completedTasksData: any = [];

  routerSubscription!: Subscription;
  regionCurrencySymbol = getRegionCurrency(true);

  sendDocketOnceAT: any = new Date();
  today = getFormattedDateTime();
  sendDocketOptionSelected: number = 1;
  configuredMailData: any = [];

  promptFileDataUrls: any = [];

  isSubContractingClient: boolean = false;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private spinnerService: LoadingSpinnerService,
    private appService: AppService,
    private jobService: JobsService,
    private dialogService: ModalDialogueService,
    private router: Router,
    private dataCheckService: DataCheckService,
    private toasterService: ToasterService,
    private route: ActivatedRoute,
    private webSocketService: WebSocketService,
    private clientService: ClientsService,
    private deviceInfoService: DeviceInfoService,
    private pageService: PagesService,
  ) {
    const userData = this.appService.getUserData();

    this.isAdmin = this.dataCheckService.isUserAdmin();

    this.subscriberUserId = userData?.subscriber?.subscriber_user_id;
    const jobId: any = this.route.snapshot.queryParamMap.get('jId');

    if (jobId) {
      localStorage.setItem('urlId', jobId);
    }

    this.webSocketSubscription =
      this.webSocketService.webSocketSubject.subscribe((event: any) => {
        const isSameUserOnAnotherDevice =
          this.subscriberUserId === event?.request_user?.subs_id &&
          this.loggedInDeviceID &&
          this.loggedInDeviceID !== event?.request_user?.logged_in_device_id;
        const isAnotherUser =
          this.subscriberUserId !== event?.request_user?.subs_id;

        const allowUser = isSameUserOnAnotherDevice || isAnotherUser;

        if (
          event?.event === 'individual_job_update' &&
          event?.data?.job_details?.id === this.detailData?.id &&
          allowUser
        ) {
          // update the changes made by someone else in realtime

          setTimeout(() => {
            this.formatData(event?.data);
          }, 100);
        }
      });
  }

  ngOnInit(): void {
    this.spinnerService.show();
    this.getJobDetails();
    this.getDeviceID();
  }
  getDeviceID() {
    if (!this.loggedInDeviceID) {
      this.loggedInDeviceID = this.deviceInfoService.getUniqueDeviceID();
    }
  }
  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
    if (this.webSocketSubscription) {
      this.webSocketSubscription?.unsubscribe();
    }
  }
  getJobDetails() {
    let id = window.localStorage.getItem('urlId');

    if (!id) {
      this.router.navigate(['/']);
    }

    this.jobService
      .getJobById(id, { preview_report: 1 })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.spinnerService.show();

          this.formatData(response);
        } else {
          this.spinnerService.hide();
        }
      });
  }

  formatData(response: any) {
    this.dialogRef?.close();
    this.detailData = response?.job_details || {};
    this.isDispatchUser = this.dataCheckService.isDispatchUser({
      permission: 'job_type',
      action: 'edit',
      id: this.detailData?.service_type?.id,
    });

    this.getSiteReportSchedules();
    this.detailData.additional_info = this.detailData?.additional_info || {};
    const hideGuardColumn = this.detailData?.additional_info?.hide_guard_column;

    if (typeof hideGuardColumn !== 'boolean') {
      this.detailData.additional_info.hide_guard_column = true;
    }

    this.cpScanPresent = response?.data?.has_cp_scan_events;
    this.completedTasksPresent = response?.data?.has_completed_tasks;
    this.hasStatusUpdates = response?.data?.has_status_updates;
    this.isSubContractingClient = response?.data?.is_subcontracting || false;
    this.completedTasksData = response?.data?.completed_task_data || [];
    this.promptFileDataUrls = response?.data?.prompt_file_data_list || [];

    this.job_details = response?.data?.job_details;
    this.timeZoneOffset = convertUTCStringToOffset(
      this.job_details?.time_zone_diff,
    );

    this.eventData = response?.data?.event_data;
    this.summaryData = response?.data?.summary_data;

    this.selectedReportRecipientSet = new Set();
    this.reportRecipientContactsDataDict = {
      site_contacts: [],
      client_contacts: [],
    };

    (response?.data?.recipients || [])?.forEach((contact: any) => {
      contact.isSelected = this.detailData?.roster_scheduler?.id
        ? contact?.is_site_contact
        : true;

      if (contact?.is_site_contact) {
        this.reportRecipientContactsDataDict.site_contacts.push(contact);
      } else {
        this.reportRecipientContactsDataDict.client_contacts.push(contact);
      }
      if (contact?.isSelected) this.selectedReportRecipientSet.add(contact?.id);
    });

    // if (this.detailData?.status?.status_identity?.value === 10) {
    //   this.router.navigate(['/jobs']);
    //   return;
    // }
    this.detailData?.service_type?.statuses?.forEach((obj: any) => {
      const statusValue = obj?.status?.status_identity?.value;
      if ([9, 10, 11, 12, 13].includes(statusValue)) {
        this.formatAfterCompleteStatus(obj);
      }
    });
    this.welfareCheckPresent = false;
    this.photoUploadPresent = false;
    let lastUpdatedStatusDict: any = {};
    if (
      [0].includes(this.detailData?.service_type?.type_identity) &&
      this.detailData?.job_received_at
    ) {
      lastUpdatedStatusDict['Alarm Received'] = {
        event_time: this.detailData?.job_received_at,
        status_identity: -1,
        value: 'Alarm Received',
      };
    }

    this.eventData?.forEach((update: any) => {
      if (update?.event_type !== 4) {
        if (
          update?.event_action === 1 &&
          [4, 5, 8, 0, 1].includes(update?.status_identity)
        ) {
          lastUpdatedStatusDict[update?.value] = update;
        }
        if (update?.event_action === 20) {
          this.welfareCheckPresent = true;
        }
        if ([8, 19].includes(update?.event_action)) {
          this.photoUploadPresent = true;
        }
      }
    });

    if (this.detailData?.service_type?.type_identity !== 2) {
      // Re open not available for static guard
      this.lastStatus = this.detailData?.service_type?.statuses?.find(
        // offsite status
        (s: any) => s?.status?.status_identity?.value === 5,
      );

      if (!this.lastStatus?.status?.id) {
        this.lastStatus = this.detailData?.service_type?.statuses?.find(
          (s: any) =>
            s?.status?.status_identity?.value === 0 &&
            s?.status?.name?.toLowerCase() === 'in progress',
        );
      }
    }
    // some job types may not have onsite and or offsite. so get the time from the statusTimestapms
    let onSiteTime: any;
    let offsiteTime: any;

    if (Object.keys(lastUpdatedStatusDict)?.length) {
      try {
        let sortedArray = Object.entries(lastUpdatedStatusDict)
          .sort(
            (a: any, b: any) =>
              new Date(a[1].event_time).getTime() -
              new Date(b[1].event_time).getTime(),
          )
          .map(([key, value]) => ({ [key]: value }));

        // Optionally, convert back to a dictionary if needed
        lastUpdatedStatusDict = Object.assign({}, ...sortedArray);
      } catch (error) {}
    }

    this.statusTimeStamps = Object.values(lastUpdatedStatusDict);

    this.statusTimeStamps?.forEach((status: any, index: number, arr: any) => {
      if (index > 0) {
        const prevStatus = arr[index - 1];
        const prevOrderIndex = this.customStatusOrder?.indexOf(
          prevStatus?.status_identity,
        );
        const currOrderIndex = this.customStatusOrder?.indexOf(
          status?.status_identity,
        );

        if (currOrderIndex < prevOrderIndex) {
          status.sortInfo = `up`;
          prevStatus.sortInfo = `down`;
        }
      }

      if (status?.status_identity === 4)
        onSiteTime = new Date(status?.event_time).getTime();
      if (status?.status_identity === 5)
        offsiteTime = new Date(status?.event_time).getTime();
    });

    if (onSiteTime && offsiteTime) {
      // filter items outisde onsite and offsite

      this.eventsOutsideStatusTimeStamps = this.eventData
        ?.filter(
          (item: any) =>
            [7, 8, 19].includes(item?.event_action) &&
            item?.event_type !== 4 &&
            !item?.is_deleted &&
            (new Date(item?.event_time).getTime() <= onSiteTime ||
              new Date(item?.event_time).getTime() >= offsiteTime),
        )
        ?.map((item: any) => item?.id);
    }
    const targetUrl = `/job-review/${this.detailData.job_key}`;

    if (this.router.url !== targetUrl) {
      this.router.navigate([targetUrl], { replaceUrl: true });
    }

    this.getShiftStartEnd();
    this.spinnerService.hide();
  }

  formatAfterCompleteStatus(statuObj: any) {
    const statusIdentiy = statuObj?.status?.status_identity?.value;
    let statusKey = '';
    switch (statusIdentiy) {
      case 9:
        statusKey = this.detailData?.sites?.[0]?.auto_send_reports
          ? ''
          : 'review';
        break;
      case 10:
        statusKey = 'approve';
        break;
    }
    if (statusKey) {
      this.jobCompleteInvoiceRelatedStatus[statusKey] = statuObj;
    }
  }
  deleteRestoreUserUpdate(event: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title:
          event?.type === 'delete' ? 'Remove From Report?' : 'Show in Report?',
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();
        let body: any = {
          id: event?.event?.id,
          job_id: this.detailData?.id,
        };
        body[event?.type === 'delete' ? 'delete_update' : 'restore_update'] = 1;

        this.jobService
          .jobUpdateWoSW(body, { preview_report: 1 })
          .then((response: any) => {
            if (response?.data) {
              this.formatData(response);
            }
            if (response?.status === 'failure') {
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response?.message,
              });
            }

            this.spinnerService.hide();
          });
      }
    });
  }

  editComment(eventData: any, requestRef: any) {
    this.newComment = eventData?.value;
    this.previousComment = eventData?.value;
    this.dialogRef = this.dialogService.open(
      requestRef,
      {
        data: eventData,
      },
      this.viewContainerRef,
    );
  }

  changeEventTimeStamp(event: any, eventData: any) {
    const selectedTime = event?.target.value
      ? new Date(event?.target.value).getTime()
      : new Date(eventData?.currentValue).getTime();

    eventData.valid =
      selectedTime !== new Date(eventData?.currentValue).getTime();
  }

  changeStatusTimeStamp(changedStatus: any, data: any) {
    const index = data.findIndex(
      (status: any) => status?.statusIdentity === changedStatus?.statusIdentity,
    );

    let updatedTimeStamp = new Date(changedStatus.newValue).getTime();

    for (let i = index - 1; i >= 0; i--) {
      const currStatus = data[i];
      let currTimestamp = new Date(currStatus.newValue).getTime();

      if (currTimestamp >= updatedTimeStamp) {
        const newDate = new Date(updatedTimeStamp);
        newDate.setMinutes(newDate.getMinutes() - 1);
        updatedTimeStamp = newDate.getTime();
        currStatus.newValue = getFormattedDateTime(newDate);
      } else {
        updatedTimeStamp = currTimestamp;
      }
    }

    updatedTimeStamp = new Date(changedStatus.newValue).getTime();

    for (let i = index + 1; i < data.length; i++) {
      const currStatus = data[i];
      let currTimestamp = new Date(currStatus.newValue).getTime();

      if (currTimestamp <= updatedTimeStamp) {
        const newDate = new Date(updatedTimeStamp);
        newDate.setMinutes(newDate.getMinutes() + 1);
        updatedTimeStamp = newDate.getTime();
        currStatus.newValue = getFormattedDateTime(newDate);
      } else {
        updatedTimeStamp = currTimestamp;
      }
    }
  }

  editStatusTimeStamp(templateRef: any) {
    const statuses = this.statusTimeStamps
      ?.map((status: any) => ({
        id: status?.id,
        currentValue: getFormattedDateTime(status?.event_time),
        newValue: getFormattedDateTime(status?.event_time),
        statusIdentity: status?.status_identity,
        status: status?.value,
      }))
      .sort((a: any, b: any) => {
        return (
          this.customStatusOrder?.indexOf(a.statusIdentity) -
          this.customStatusOrder?.indexOf(b.statusIdentity)
        );
      })
      .map((status: any, index: number, arr: any) => {
        if (index > 0) {
          const prevStatus = arr[index - 1];
          const prevTimestamp = new Date(prevStatus.newValue).getTime();
          const currTimestamp = new Date(status.newValue).getTime();
          if (currTimestamp <= prevTimestamp) {
            const newDate = new Date(prevTimestamp);
            newDate.setMinutes(newDate.getMinutes() + 1);
            status.newValue = getFormattedDateTime(newDate);
          }
        }
        return status;
      });
    const dialogRef = this.dialogService.open(
      templateRef,
      { data: statuses },
      this.viewContainerRef,
    );
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        const updateDict: any = {};
        let reqBody: any = {};
        data?.forEach((status: any) => {
          if (
            new Date(status?.currentValue).getTime() !==
            new Date(status?.newValue).getTime()
          ) {
            if (status?.id) {
              updateDict[String(status?.id)] = new Date(status?.newValue);
            } else {
              if (status?.statusIdentity === -1) {
                reqBody['job_received_at'] = new Date(status?.newValue);
                // this means the received at time is changed
              }
            }
          }
        });

        if (Object.values(updateDict)?.length) {
          reqBody = {
            ...reqBody,
            change_status_timestamps: 1,
            updated_time_stamps: updateDict,
          };
        }
        if (Object.values(reqBody)?.length) {
          this.updateData(reqBody);
        }
      }
    });
  }
  editTimeStamp(
    event: any,
    timeStampTempRef: any,
    changeTimeStampTemplate?: any,
  ) {
    const currentValue = getFormattedDateTime(event?.event_time);
    if (event?.event_action === 100000) {
      this.editStatusTimeStamp(changeTimeStampTemplate);
    } else {
      const dialogRef = this.dialogService.open(
        timeStampTempRef,
        {
          data: {
            name: event?.event_action === 1 ? event?.value : event?.action,
            currentValue: currentValue,
            newValue: currentValue,
          },
        },
        this.viewContainerRef,
      );

      dialogRef.afterClosed().subscribe((value: any) => {
        if (value !== false) {
          let body: any = {
            event_id: event?.id,
            user_provided_timestamp: new Date(
              value?.newValue || value?.currentValue,
            ),
            change_event_timestamp: 1,
            event_type: event?.event_type ? String(event?.event_type) : null,
          };
          this.updateData(body);
        }
      });
    }
  }

  clearAndFocusTextBox(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 100);
  }
  addComment(data?: any) {
    if (!data?.id && !this.newComment?.trim()) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage: 'Comment cannot be empty',
      });
      return;
    }

    this.spinnerService.show();
    let body: any = {
      job_id: this.detailData?.id,
      comment: this.newComment,
    };
    if (Object.keys(data).length) {
      body.id = data?.id;
      body.edit_comment = 1;
    }
    this.jobService
      .jobUpdateWoSW(body, { preview_report: 1 })
      .then((response: any) => {
        if (response?.data) {
          this.formatData(response);
        }
        if (response?.status === 'failure') {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }

        this.spinnerService.hide();
      });
  }
  deleteComment(data: any) {
    this.spinnerService.show();
    let body: any = {
      job_id: this.detailData?.id,
      comment: '',
    };
    if (Object.keys(data).length) {
      body.id = data?.id;
      body.edit_comment = 1;
    }
    this.jobService
      .jobUpdateWoSW(body, { preview_report: 1 })
      .then((response: any) => {
        if (response?.data) {
          this.formatData(response);
        }
        if (response?.status === 'failure') {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }

        this.spinnerService.hide();
      });
  }
  modifyJobExtraInfo(requestRef: any, _type: string, currentValue: any) {
    if (this.isAdmin === true || this.isDispatchUser === true) {
      this.updatedJobExtraInfo = currentValue;
      this.dialogRef = this.dialogService.open(
        requestRef,
        { data: { _type: _type, currentValue: currentValue } },
        this.viewContainerRef,
      );
    }
  }
  updateRequestDetails(_type: string) {
    let body: any = {};
    body[_type === 'in' ? 'internal_notes' : 'request'] =
      this.updatedJobExtraInfo;
    this.updateData(body);
  }
  modifyExternalJobId(template: any) {
    this.externalNewJobId = this.detailData?.ext_job_id;
    this.externalOldJobId = this.detailData?.ext_job_id;
    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
    this.dialogRef.afterClosed().subscribe(() => {});
  }
  updateJobId() {
    this.updateData({ external_job_id: this.externalNewJobId });
  }
  updateData(body: any) {
    let requestData: any = {};
    requestData['method'] = 'put';
    requestData['url'] = 'api/job/' + this.detailData.id + '/';
    requestData['id'] = this.detailData.id;
    requestData['data'] = body;
    this.spinnerService.show();
    this.jobService
      .updateJob(requestData, { preview_report: 1 })
      .then((response: any) => {
        if (response?.data) {
          this.formatData(response);
        }
        if (response?.status === 'failure') {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }

        this.spinnerService.hide();
      });
  }
  async approveJob(template: any) {
    const dialogRef = this.dialogService.open(
      template,
      {},
      this.viewContainerRef,
    );
    const dResponse = await firstValueFrom(dialogRef.afterClosed());

    if (dResponse === true) {
      // detailData?.status?.status_identity?.value == 9
      let reqBody: any = {
        recipient_ids: [...this.selectedReportRecipientSet],
      };
      if (this.detailData?.status?.status_identity?.value == 9) {
        if (
          this.detailData?.status?.id !==
          this.jobCompleteInvoiceRelatedStatus?.approve?.status?.id
        ) {
          reqBody.job_status_id =
            this.jobCompleteInvoiceRelatedStatus?.approve?.status?.id;
        }
        if (this.sendDocketOptionSelected == 2 && this.sendDocketOnceAT) {
          reqBody.mail_time = new Date(this.sendDocketOnceAT);
        } else {
          reqBody.send_report = true;
        }
      } else {
        // resend option
        if (this.sendDocketOptionSelected == 2 && this.sendDocketOnceAT) {
          reqBody.mail_time = new Date(this.sendDocketOnceAT);
        } else {
          reqBody.resend_report = true;
        }
      }

      this.updateData(reqBody);
    }
  }

  moveJobBack() {
    const dialogRef = this.dialogService.open(
      ConfirmDialogComponent,
      {
        data: {
          title: 'Reopen Job',
          message: '',
        },
      },
      this.viewContainerRef,
    );
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.updateData({
          job_status_id: this.lastStatus?.status?.id,
        });
      }
    });
  }
  openAddCommentTemplate(requestRef: any) {
    this.newComment = '';
    this.dialogRef = this.dialogService.open(
      requestRef,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }
  openCamPopup() {
    this.dialogRef = this.dialogService.open(FileUploadComponent, {
      data: {
        showFrom: 'updateJob',
      },
    });
    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value && value !== 'error') {
        this.spinnerService.show('Uploading - Please Wait');
        let fileData: FormData = new FormData();

        fileData.append('file', value.actualFileUpload);
        if (value.newComment) {
          fileData.append('comment', value.newComment);
        }
        let url = `job/update_job_wo_sw`;
        fileData.append('job_id', this.detailData?.id);
        fileData.append('image_source', value?.uploadType);
        fileData.append(
          'jobDetails',
          JSON.stringify({
            job_key: this.detailData?.job_key,
            company: this.detailData?.company?.company_name,
          }),
        );

        if (value?.exifData && Object.values(value?.exifData)?.length) {
          fileData.append('exif_data', JSON.stringify(value?.exifData));
        }
        this.appService
          .formDataApi(url, fileData, false, { preview_report: 1 })
          .then((response: any) => {
            if (response?.data) {
              this.formatData(response);
            }
            if (response?.status === 'failure') {
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response?.message,
              });
            }

            this.spinnerService.hide();
          });
      } else if (value == 'error') {
        this.toasterService.setMessage({
          errorMessage: 'Unable to access your camera',
        });
      }
    });
  }
  scrollToSection(event: Event, sectionId: string) {
    event.preventDefault();
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
  }
  onMcSearch(event: any) {
    this.mcInputValue = event?.target?.value;
    if (event?.target?.value.length > 2) {
      this.getMonitoringCompanyList({ search_str: event?.target?.value });
    }
  }

  getMonitoringCompanyList(params?: any) {
    this.clientService
      .fetchMonitoringCompanyList(params)
      .subscribe((res: any) => {
        if (res['status'] == 'success') {
          this.monitoringCompanyList = res['data'];
        }
      });
  }
  modifyMonitoringCompany(requestRef: any) {
    this.getMonitoringCompanyList();
    this.mcInputValue = this.detailData?.monitoring_company?.company_name;
    this.dialogRef = this.dialogService.open(
      requestRef,
      {
        data: {},
      },
      this.viewContainerRef,
    );
    this.dialogRef.afterClosed().subscribe(() => {});
  }
  addMC(monitoringCompany: any) {
    if (monitoringCompany.key === 0) {
      this.openAddMonitoringCompany();
    }
    this.updateData({ monitoring_company_id: monitoringCompany?.id });
    this.dialogRef.close();
  }
  openAddMonitoringCompany() {
    if (this.mcInputValue?.length > 0) {
      this.spinnerService.show();
      this.clientService
        .createMonitoringCompany({
          company_name: String(this.mcInputValue),
        })
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.spinnerService.hide();
            this.addMC(response?.data);
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              errorMessage: response['message'],
              successMessage: '',
            });
          }
        });
    } else {
      this.toasterService.setMessage({
        errorMessage: "Monitoring Company value can't be empty",
        successMessage: '',
      });
    }
  }
  getResponseTypes(params?: any) {
    this.clientService.fetchResponseTypeList(params).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.responseTypeList = res['data'];

        this.initalResponseTypeList = JSON.parse(JSON.stringify(res?.data));
      }
    });
  }
  openUpdateResponseTypeTemplate(template: TemplateRef<any>) {
    this.getResponseTypes();
    this.previousResponseTypeValue = this.detailData?.response_type?.name;

    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }
  onSelectResponseType(event: any) {
    if (event?.key === 0) {
      this.openAddResponseTypeForm();
    }
    if (event?.id) {
      let body: any = {
        response_type_id: event?.id,
      };

      this.updateData(body);
    }
  }
  onSearchResponseType(event: any) {
    this.previousResponseTypeValue = event.target.value;
    if (event.target.value.length) {
      this.responseTypeList = this.initalResponseTypeList?.filter((type: any) =>
        type?.name?.toLowerCase()?.includes(event.target.value?.toLowerCase()),
      );
    } else {
      this.responseTypeList = this.initalResponseTypeList;
    }
  }

  openAddResponseTypeForm() {
    if (this.previousResponseTypeValue.length > 0) {
      this.spinnerService.show();
      this.clientService
        .createResponseType({
          name: String(this.previousResponseTypeValue),
        })
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.spinnerService.hide();
            this.onSelectResponseType(response?.data);
            this.getResponseTypes();
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              errorMessage: response['message'],
              successMessage: '',
            });
          }
        });
    } else {
      this.toasterService.setMessage({
        errorMessage: "Response Type Name can't be empty",
        successMessage: '',
      });
    }
  }
  editField(field: string) {
    if (field == 'rt') {
      this.previousResponseTypeValue = null;
      this.responseTypeList = this.initalResponseTypeList;
      this.shiftFocus('rtId');
    }
    if (field == 'mc') {
      this.mcInputValue = null;
      this.getMonitoringCompanyList();
      this.shiftFocus('mcId');
    }
  }
  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    });
  }
  openUpdateServiceTypeTemplate(template: TemplateRef<any>) {
    this.getServiceTypes();
    this.previousServiceTypeValue = this.detailData?.job_service_type?.name;

    this.dialogRef = this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }
  onSTSearch(event: any) {
    this.previousServiceTypeValue = event.target.value;

    if (event.target.value.length) {
      this.serviceTypeListData = this.initalServiceTypeListData?.filter(
        (type: any) =>
          type?.name
            ?.toLowerCase()
            ?.includes(event.target.value?.toLowerCase()),
      );
    } else {
      this.serviceTypeListData = this.initalServiceTypeListData;
    }
  }

  getServiceTypes(params?: any) {
    this.clientService.fetchServiceTypeList(params).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.serviceTypeListData = res['data'];

        this.initalServiceTypeListData = JSON.parse(JSON.stringify(res?.data));
      }
    });
  }
  onServiceTypeSelect(sType: any) {
    if (sType.key === 0) {
      this.openAddServiceType();
    }
    if (sType?.id) {
      let body: any = {
        service_type_id: sType?.id,
      };

      this.updateData(body);
    }
  }
  openAddServiceType() {
    if (this.previousServiceTypeValue.length > 0) {
      this.spinnerService.show();
      this.clientService
        .createServiceType({ name: String(this.previousServiceTypeValue) })
        .then((response: any) => {
          if (response['status'] == 'success') {
            this.spinnerService.hide();
            this.onServiceTypeSelect(response?.data);

            this.getServiceTypes();
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              errorMessage: response['message'],
              successMessage: '',
            });
          }
        });
    } else {
      this.toasterService.setMessage({
        errorMessage: "Service Type value can't be empty",
        successMessage: '',
      });
    }
  }
  redirectToSite(route = 'site') {
    if (route === 'site') {
      this.router.navigate(
        ['/view-site', { sKey: String(this.detailData?.sites?.[0]?.id) }],
        { fragment: 'jc' },
      );
    } else {
      this.router.navigate(
        ['/view-client', { cKey: String(this.detailData?.company?.id) }],
        { fragment: 'jc' },
      );
    }
  }
  selectAllContactReportRecipients(event: any, contactList: any) {
    const checked = event.target.checked;
    const contactIds = contactList?.map((item: any) => item?.id) || [];
    if (checked) {
      contactIds?.forEach((contactId: any) => {
        this.selectedReportRecipientSet.add(contactId);
      });
    } else {
      contactIds?.forEach((contactId: any) => {
        if (this.selectedReportRecipientSet.has(contactId)) {
          this.selectedReportRecipientSet.delete(contactId);
        }
      });
    }
  }
  selectUnselectRecipients(contact: any) {
    if (this.selectedReportRecipientSet.has(contact?.id)) {
      this.selectedReportRecipientSet.delete(contact?.id);
    } else {
      this.selectedReportRecipientSet.add(contact?.id);
    }
  }
  onOpenImage(event: any, data: any) {
    var target = event.target || event.srcElement || event.currentTarget;
    var srcAttr = target.attributes.src;

    this.dialogRef = this.dialogService.open(MediaPreviewComponent, {
      data: { mediaSrc: srcAttr.nodeValue, timeStamp: data.updated_at },
    });
  }
  openReportDateTemplate(template: any) {
    const currentValue = getFormattedDate(
      this.detailData?.additional_info?.report_date
        ? new Date(this.detailData?.additional_info?.report_date)
        : new Date(),
    );

    const dialogRef = this.dialogService.open(
      template,
      {
        data: {
          currentValue: currentValue,
          newValue: currentValue,
          minDateTime: null,
          maxDateTime: getFormattedDate(new Date()),
        },
      },
      this.viewContainerRef,
    );
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value)
        this.updateData({ report_date: new Date(value?.newValue).getTime() });
    });
  }
  openSealInfoTemplate(template: any) {
    this.sealInfo = this.detailData?.seal_info;
    this.dialogRef = this.dialogService.open(
      template,
      {},
      this.viewContainerRef,
    );
  }
  getShiftStartEnd() {
    if (this.detailData?.roster_scheduler?.repeat_type) {
      let startTime = this.detailData?.schedule_event_date
        ? new Date(this.detailData?.schedule_event_date)
        : new Date();
      let endTime = this.detailData?.schedule_event_date
        ? new Date(this.detailData?.schedule_event_date)
        : new Date();

      if (this.detailData?.roster_scheduler?.repeat_type == 'once') {
        startTime = new Date(
          this.detailData?.roster_scheduler?.start_day +
            ' ' +
            this.detailData?.roster_scheduler?.start_time,
        );
        endTime = new Date(
          this.detailData?.roster_scheduler?.end_day +
            ' ' +
            this.detailData?.roster_scheduler?.end_time,
        );
      } else {
        if (
          this.detailData?.roster_scheduler?.start_time >
          this.detailData?.roster_scheduler?.end_time
        ) {
          endTime.setDate(startTime.getDate() + 1);
        }
        this.setTime(startTime, this.detailData?.roster_scheduler?.start_time);
        this.setTime(endTime, this.detailData?.roster_scheduler?.end_time);
      }

      this.detailData.roster_scheduler.shiftStartDateTime = startTime;
      this.detailData.roster_scheduler.shiftEndDateTime = endTime;
      this.detailData.roster_scheduler.shiftDuration = this.getTimeDiff(
        startTime,
        endTime,
      );
    }
  }
  roundDateTimeToQuarterHour = (event: any) => {
    const newDate = new Date(event.target.value);
    newDate.setHours(newDate.getHours(), newDate.getMinutes(), 0, 0);
    const msPerQuarter = 15 * 60 * 1000;
    const rounded = Math.round(newDate.getTime() / msPerQuarter) * msPerQuarter;
    setTimeout(() => {
      this.sendDocketOnceAT = getFormattedDateTime(rounded);
    }, 500);
  };

  setTime(date: Date, time: string) {
    const [hours, minutes] = time?.split(':');
    date.setHours(parseInt(hours));
    date.setMinutes(parseInt(minutes));
  }
  getTimeDiff(startTime: any, endTime: any) {
    let diffInTime = endTime?.getTime() - startTime?.getTime();

    if (!diffInTime) return '00:00';
    let seconds = Math.floor(diffInTime / 1000);
    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds % 3600) / 60);

    return `${this.pad(hours)}:${this.pad(minutes)}`;
  }
  pad(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }
  getOnsiteTime(statusTimeStamps: any) {
    let onSiteTime: any;
    let offsiteTime: any;
    statusTimeStamps?.forEach((status: any) => {
      if (status?.statusIdentity == 4) {
        onSiteTime = new Date(status?.newValue);
      }
      if (status?.statusIdentity == 5) {
        offsiteTime = new Date(status?.newValue);
      }
    });
    if (onSiteTime && offsiteTime) {
      return this.getTimeDiff(onSiteTime, offsiteTime);
    }
    return null;
  }
  copyContentToClipBoard(content: string) {
    // this.clipboard.copy(couponData?.event?.code);
    this.toasterService.copyContentToClipBoard(content);
  }
  routeToJobDetailPage() {
    this.router.navigate([`/job-detail/${this.detailData?.job_key}`], {
      queryParams: { jId: this.detailData?.id },
      replaceUrl: true,
    });
  }
  sendDocket(template: any, reportConfirmationTemplate: any) {
    this.sendDocketOptionSelected = 1;
    const todayAt10 = new Date();
    todayAt10.setHours(10, 0, 0, 0);
    if (new Date().getTime() > todayAt10.getTime()) {
      todayAt10.setDate(todayAt10.getDate() + 1);
    }
    this.sendDocketOnceAT = getFormattedDateTime(todayAt10);
    const dialogRef = this.dialogService.open(
      template,
      {},
      this.viewContainerRef,
    );
    dialogRef?.afterClosed().subscribe((res: any) => {
      if ([1, 2].includes(res)) {
        this.approveJob(reportConfirmationTemplate);
      }

      if (res === 3) {
        const dialogRef = this.dialogService.open(
          AddScheduledReportsComponent,
          {
            data: {
              detailData: {
                site_data: {
                  ...this.detailData?.sites?.[0],
                  company: this.detailData?.company,
                },
                job_type_id: this.detailData?.service_type?.id,
              },
            },
          },
        );
        dialogRef.afterClosed().subscribe((response: any) => {
          if (res) {
            this.getSiteReportSchedules();
          }

          this.spinnerService.hide();
        });
      }
    });
  }
  openSendDocketTemplate(template: any, reportConfirmationTemplate: any) {
    if (
      [9, 11, 12, 13, 1, 10].includes(
        this.detailData?.status?.status_identity?.value,
      )
    ) {
      this.sendDocket(template, reportConfirmationTemplate);
    } else {
      const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
        data: {
          title: 'Send Docket',
          message: 'This job has been reopened. Continue sending docket?',
        },
      });
      dialogRef.afterClosed().subscribe((value: any) => {
        if (value === true) {
          this.sendDocket(template, reportConfirmationTemplate);
        }
      });
    }
  }
  getSiteReportSchedules() {
    if (!this.detailData?.id || !this.detailData?.sites?.[0]?.id) return;
    this.clientService
      .getJobQueuedReports({
        job_id: this.detailData?.id,
        site_id: this.detailData?.sites?.[0]?.id,
      })
      .subscribe((res: any) => {
        this.configuredMailData = res?.data || [];
        if (this.detailData?.mail_time) {
          this.configuredMailData?.push({
            mail_time: this.detailData?.mail_time,
          });
        }
      });
  }
  redirectToScheduledReportsTab(scheduleData: any) {
    sessionStorage.setItem('selectedTab', 'Scheduled Reports');
    this.router.navigate(['/reports'], {
      queryParams: { sKey: btoa(scheduleData?.id) },
    });
  }
  removeSchedule(scheduleData: any) {
    // case 1: exclude job from the site/client scheduled report
    // case 2: stop/remove the docket being sent out at a particular time (send later option)
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Delete Scheduled Report',
        message: scheduleData?.id ? '' : 'Stop sending out docket',
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();
        if (scheduleData?.id) {
          this.clientService
            .updateScheduledPatrolReprotById(
              btoa(scheduleData?.id),
              { job_id: this.detailData?.id },
              { remove_job_from_queue: 1 },
            )
            .subscribe((response: any) => {
              if (response['status'] == 'success') {
                this.getSiteReportSchedules();

                this.spinnerService.hide();
              } else {
                this.spinnerService.hide();
                this.toasterService.setMessage({
                  successMessage: '',
                  errorMessage: response['message'],
                });
              }
            });
        } else {
          this.updateData({ mail_time: null });
        }
      }
    });
  }
  printInvoice(invoiceId: any) {
    if (!invoiceId) return;
    this.router.navigate([
      '/print-invoice',
      { invKey: btoa(String(invoiceId)) },
    ]);
  }
  modifyLetterHeadLogo() {
    const dialogRef = this.dialogService.open(ModifyLetterheadLogoComponent, {
      data: {
        logoUsed: this.job_details?.subscriber_info?.logo_used,
        siteData: {
          id: this.detailData?.sites?.[0]?.id,
          company_name: this.detailData?.sites?.[0]?.company_name,
        },
        clientData: {
          id: this.detailData?.company?.id,
          company_name: this.detailData?.company?.company_name,
          is_subcontracting: this.detailData?.company?.is_subcontracting,
        },
      },
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.getJobDetails();
      }
    });
  }
  editTaskCompletedTimeStamp(event: any, timeStampTempRef: any) {
    const currentValue = getFormattedDateTime(event?.updated_datetime);

    const dialogRef = this.dialogService.open(
      timeStampTempRef,
      {
        data: {
          name: 'Task Completed Time',
          currentValue: currentValue,
          newValue: currentValue,
        },
      },
      this.viewContainerRef,
    );

    dialogRef.afterClosed().subscribe((value: any) => {
      if (value !== false) {
        let body: any = {
          event_id: event?.id,
          user_provided_timestamp: new Date(
            value?.newValue || value?.currentValue,
          ),
          change_task_completed_timestamp: 1,
        };
        this.updateData(body);
      }
    });
  }
  async openSubBillerTemplate() {
    const dialogRef = this.dialogService.open(SelectSubBillerComponent, {
      data: { selectedSubBiller: this.detailData?.sites?.[0]?.sub_biller },
    });
    const dialogResp = await firstValueFrom(dialogRef.afterClosed());
    if (!dialogResp) return;
    if (dialogResp == 'remove') {
      this.spinnerService.show('Removing Sub Biller');
      this.updateSiteDetails({}, { change_sub_biller: 1 });
    }
    if (dialogResp?.id) {
      this.spinnerService.show('Changing Sub Biller');
      this.updateSiteDetails(
        { sub_biller_id: dialogResp?.id },
        { change_sub_biller: 1 },
      );
    }
  }
  updateSiteDetails(body: any, params: any) {
    const siteId = this.detailData?.sites?.[0]?.id;
    this.clientService
      .updateSite(siteId, body, params)
      .then((response: any) => {
        if (response['status'] == 'success') {
          this.getJobDetails();
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
        this.spinnerService.hide();
      });
  }
}
